import type { BoxProps } from '@mui/material';
import { Box as BaseBox } from '@mui/material';

export default function Box(props: BoxProps) {
  return <BaseBox {...props} />;
}
